import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../loaders/SkeletonTicketList";
import { BrandTemplateDropdown, DeleteBrandTemplate, GetBrandTemplateList, GetBrandTemplateListCancelToken } from "../../services/BrandTemplateServices";
import { handleTableScroll } from "../../utils/commonFunction";
import { BrandTemplateStatus, RenderWebsiteBrand } from "../../utils/CommonStatusItems";
import { TABLE_ROWS_PER_PAGE } from "../../utils/Constants";
import PermissionsGate from "../../utils/permissionGate";
import { popupConfirmDeleteWarning } from "../../utils/Popups";
import Tablefilter from "../common/Tablefilter";
import { TrimText } from "../common/TrimText";

function BrandTemplates() {

    const [search, setSearch] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [brand, setBrand] = useState({ arr: [], checkObj: {} });
    const [linkedDomain, setLinkedDomain] = useState({ arr: [], checkObj: {} });
    const [expandedRows1,setExpandedRows1] = useState([])
    const [searchStatusCheck, setSearchStatusCheck] = useState({});
    const [updateData, setUpdateData] = useState(true);
    const [templateData, setTemplateData] = useState([]);
    const [loading, setloading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("templateName");
    const [sortOrder, setSortOrder] = useState("ASC");
    const [filterData, setFilterData] = useState({ status: [], brand: [], linkedDomain: [] });

    useEffect(() => {
        handleTableScroll()
    }, [loading])
    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })
    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("filterStateBrandTemplate"));
        if (storedFilters) {
            setStatus(storedFilters.status);
            setBrand(storedFilters.brand);
            setLinkedDomain(storedFilters.linkedDomain);
            setFilterData(storedFilters.filterData);
        }
    }, []);
    useEffect(() => {
        const filterState = {
            status,
            brand,
            linkedDomain,
            filterData
        };
        localStorage.setItem("filterStateBrandTemplate", JSON.stringify(filterState));
    }, [status, brand, linkedDomain, filterData]);
    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })
    useEffect(() => {
        const cancelTokenSources = [];

        const getWebsiteList = async () => {
            setloading(true);

            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
            });

            const source = axios.CancelToken.source();
            cancelTokenSources.push(source);

            const websiteData = {
                page: page,
                perPage: perPage,
                key: sortkey,
                sort: sortOrder,
                search: search,
                exportStaus: false,
                viaStatus: status.arr,
                viaBrand: brand.arr,
                viaSiteLink: linkedDomain.arr,
            };

            try {
                const res = await GetBrandTemplateListCancelToken(websiteData, source.token);
                setTemplateData(res?.data?.data?.data);
                setTotalRows(res.data?.data?.total);
                setPerPage(res.data?.data?.perPage);
                if (res.status == 200) {
                    setloading(false);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                    setloading(false);
                }
            }
        }

        getWebsiteList();

        return () => {
            cancelTokenSources.forEach(source => {
                source.cancel('Component unmounted');
            });
        };
    }, [page, perPage, sortOrder, sortkey, search, status, brand, linkedDomain, searchStatusCheck, updateData]);

    useEffect(() => {
        const dropdownSource = axios.CancelToken.source();

        const fetchData = async () => {
            try {
                const res = await BrandTemplateDropdown(dropdownSource.token);
                setFilterData({
                    ...res.data, status: res.data.status ? res.data.status : [], brand: res.data.brand ? res.data.brand : [], linkedDomain: res.data.siteLink || []
                });
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
        };

        fetchData();

        return () => {
            dropdownSource.cancel('Component unmounted');
        };
    }, []);

    usePermissionGuardRedirect(['wbssitebrandtmpview']);

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        setStatus({ arr: [], checkObj: {} });
        setBrand({ arr: [], checkObj: {} });
        setLinkedDomain({ arr: [], checkObj: {} });
        setSearchStatusCheck({});
        setSearch("");
        setDebouncedTerm("")
    };

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const handleSort = (column, sortDirection) => {
        setSortKey(column.sortField);
        setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
    };


    const handleDelete = (id) => {
        popupConfirmDeleteWarning((result) => {
            if (result.isConfirmed) {
                DeleteBrandTemplate({ id: id })
                    .then((res) => {
                        Swal.fire("Deleted!", "Brand Template has been deleted.", "success");
                        setUpdateData(!updateData);
                    })
                    .catch((error) => console.log(error));
            }
        });
    }

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "templateName",
            sortField: "templateName",
            sortable: true,
            cell: (row) => (
                <PermissionsGate scopes={['wbssitebrandtmpedit']} RenderError={() => (<p>{row?.templateName}</p>)}>

                <Link
                    className="as-text-blue curser feature-name"
                    to={`/websiteManagement/siteSetup/brand_Templates/brand_information/update/${row.brandID}`}
                    title={row.templateName}
                    >
                    <span className="textLimit100">{row.templateName}</span>
                </Link >
                </PermissionsGate>
            ),
        },
        {
            name: "Linked Domain",
            selector: "siteDomain",
            sortField: "siteDomain",
            cell: (row) => {
                const module = row.core_module || [];
                const showLimit = 2;
                const shouldDisplaySeeMore = module.length > showLimit;
        
                const toggleExpanded = (rowId) => {
                  if (expandedRows1.includes(rowId)) {
                    setExpandedRows1(expandedRows1.filter((id) => id !== rowId));
                  } else {
                    setExpandedRows1([...expandedRows1, rowId]);
                  }
                };
        
                return (
                  <>
                    <>
                      {(row?.getSiteLink?.length > 3 ? row?.getSiteLink?.slice(0, showLimit) : row?.getSiteLink).map(
                        (item, index) => (
                          <li key={index} className="as-text-blue cursor">
                            <Link
                              to={`/program-management-center/modules/module/open/${item.brandID}`}
                              className="as-text-blue cursor"
                              title={item.name}
                            >
                              {TrimText(item.siteDomain, 25)}
                            </Link>
                          </li>
                        )
                      )}
                      {row?.getSiteLink?.length > 3 && !expandedRows1.includes(row.brandID) && (
                        <span
                          className="see-more cursor-pointer as-text-blue"
                          onClick={() => toggleExpanded(row.brandID)}
                        >
                          See more...
                        </span>
                      )}
                      {expandedRows1.includes(row.brandID) && (
                        <>
                          {row?.getSiteLink?.slice(showLimit).map((item, index) => (
                            <li key={index} className="as-text-blue cursor">
                              <Link
                                to={`/program-management-center/modules/module/open/${item.brandID}`}
                                className="as-text-blue cursor"
                                title={item.name}
                              >
                                {TrimText(item.siteDomain, 25)}
                              </Link>
                            </li>
                          ))}
                          <span
                            className="see-less cursor-pointer as-text-blue"
                            onClick={() => toggleExpanded(row.brandID)}
                          >
                            See less...
                          </span>
                        </>
                      )}
                      {row?.getSiteLink?.length === 0 && (
                        <span className="articulation-programme-status">N/A</span>
                      )}
                    </>
                  </>
                );
              },
        },
        {
            name: "Brand",
            selector: "brand_name",
            sortField: "brand_name",
            sortable: true,
            cell: (row) => (
                <Link
                    className="as-text-blue curser feature-name"
                    to={`/administration/brandSetting/editBrand/${row.brandLinked}`}
                    title={row.brand_name}
                >
                    <span className="textLimit100 as-blue-type-bg">{row.brand_name}</span>
                </Link >
            ),
        },
        {
            name: "Status",
            selector: "status",
            sortField: "status",
            cell: (row) => (row.status !== null ? BrandTemplateStatus(row.status).html : "-"),
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        <PermissionsGate
                            scopes={["wbssitebrandtmpedit"]}
                            RenderError={() => (
                                <button
                                    className="btn btn-primary rounded-circle"
                                    title="Open"
                                    disabled
                                >
                                    <i className="fal fa-folder-open"></i>
                                </button>
                            )}
                        >
                        <Link
                            className="btn btn-primary rounded-circle"
                            to={`/websiteManagement/siteSetup/brand_Templates/brand_information/update/${row.brandID}`}
                            title="Open"
                        >
                            <i className="fal fa-folder-open"></i>
                        </Link>
                        </PermissionsGate>
                        <PermissionsGate scopes={['wbssitebrandtmpdelete']} RenderError={() => (
                            <button
                                className="btn btn-danger rounded-circle"
                                title="Open"
                                disabled
                            >
                                <i className="fal fa-trash-alt"></i>
                            </button>
                        )}>

                        <button
                            className="btn btn-danger rounded-circle"
                            onClick={() => handleDelete(row.brandID)}
                            title="Delete"
                            type="submit"
                            >
                            <i className="fal fa-trash-alt"></i>
                        </button>
                            </PermissionsGate>
                    </div>
                </div>
            ),
        },
    ]);


    const exportData = (fileType, fileName) => {
        let data = [];
        const header = ["Name", "Linked Sites", "Brand", "Status"];
        Swal.fire({
            title: "File downloading",
            onOpen: function () {
                Swal.showLoading();
            },
        });

        const templateData = {
            page: page,
            perPage: perPage,
            key: sortkey,
            sort: sortOrder,
            search: search,
            exportStatus: true,
            viaStatus: status.arr,
            viaBrand: brand.arr,
            viaSiteLink: linkedDomain.arr,
        };

        GetBrandTemplateList(templateData)
            .then((res) => {
                data = res.data.data;
                data = data?.map((row) => ({
                    ...row,
                    Name: row?.templateName || "",
                    "Linked Sites": row.getSiteLink ? row.getSiteLink.map((d, i) => d?.siteDomain).join(",") :"-",
                    Brand: row?.brand_name ? row?.brand_name : "-",
                    Status: row?.status ? BrandTemplateStatus(row.status)?.text
                        : "-",
                }));

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    // Create new tag for download file
                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    setTimeout(() => {
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                    Swal.close();
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    return false;
                }
                if (fileType === "pdf") {
                    const compatibleData = data.map((row) => {
                        return [
                            row?.templateName,
                            row.getSiteLink.map((d, i) => d?.siteDomain).join(",") || "-",
                            row.brand_name,
                            BrandTemplateStatus(row.status)?.text ||"-",
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch((err) => {
                Swal.close();
                console.log(err);
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [debouncedTerm])

    return (
        <div className="my-tickets-info-list Tickets-main-wrap">
            <div className="custom-table-div filter-search-icon card card-table-custom program-table">
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                    <div id="assessment-table-main_filter" className="dataTables_filter">
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={handleSearchFilter}
                                                value={debouncedTerm}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                <i className="fal fa-filter"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Status"
                                            optionArr={filterData?.status}
                                            state={status}
                                            setState={setStatus}

                                            renderLabelFunction={BrandTemplateStatus}
                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Brand"
                                            optionArr={filterData?.brand}
                                            state={brand}
                                            setState={setBrand}
                                            renderLabelFunction={RenderWebsiteBrand}
                                            uniqueId="brand"

                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Linked Domain"
                                            optionArr={filterData?.linkedDomain}
                                            state={linkedDomain}
                                            setState={setLinkedDomain}
                                        />
                                    </div>
                                </div>
                                <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            onClick={resetFilter}
                                            title="Reset"
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("xlsx", "Brand_Templates_list");
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", "Brand_Templates_list");
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", "Brand_Templates_list");
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter-div-right">
                        <div className=" filter-search-bar-blk">
                            <div className="add-ticket-blk button-reset dropdown-comman">
                                <PermissionsGate
                                    RenderError={() => (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                            disabled
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    )}
                                    scopes={["wbssitebrandtmpadd"]}
                                >
                                    <Link to={`/websiteManagement/siteSetup/brand_Templates/brand_information/create`}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    </Link>
                                </PermissionsGate>
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    paginationDefaultPage={page}
                    progressPending={loading}
                    data={templateData}
                    progressComponent={<SkeletonTicketList />}
                    defaultSortField="templateName"
                    defaultSortAsc={true}
                    columns={columns}
                    pagination={true}
                    onSort={handleSort}
                    sortServer
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    highlightOnHover={false}
                    paginationPerPage={perPage}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
            </div>
        </div>
    );
}

export default BrandTemplates;
